"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAffordableAssetData = exports.affordableAssetFormRules = exports.affordableAssetFieldMapping = exports.affordableAssetSchema = void 0;
const converters_1 = require("../../converters");
const asset_1 = require("./asset");
exports.affordableAssetSchema = {
    fields: {
        ...asset_1.assetSchema.fields,
    },
    messages: {
        ...asset_1.assetSchema.messages,
    },
};
delete exports.affordableAssetSchema.fields.account_number;
delete exports.affordableAssetSchema.messages.account_number;
delete exports.affordableAssetSchema.fields.routing_number;
delete exports.affordableAssetSchema.messages.routing_number;
// Field mapping between DTO naming and UI naming
exports.affordableAssetFieldMapping = {
    ...asset_1.assetFieldMapping,
};
delete exports.affordableAssetFieldMapping.account_number;
// 🚀 Pre-computed validations for performance
exports.affordableAssetFormRules = (0, converters_1.toReactHookForm)(exports.affordableAssetSchema, exports.affordableAssetFieldMapping);
exports.validateAffordableAssetData = (0, converters_1.createValidator)(exports.affordableAssetSchema);
